import { Spin, Table } from "antd";
import { useEffect, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { getDashboardApi } from "mock/dashboardDemoData";
import { managerQuery } from "./managerScope";

const EquipmentOverview = ({ showModalState, setShowModalState }) => {

    const [equipmentOverviewData, setEquipmentOverviewData] = useState({ result: [] });
    const [isLoading, setIsLoading] = useState(true);
    const [dataSource, setDataSource] = useState([]);
    const [hasError, setHasError] = useState(false);
    const clientId = localStorage.getItem("client_id");

    useEffect(() => {
        let isMounted = true;
        let timeoutId = null;
        
        const fetchData = async () => {
            if (isMounted) {
                setIsLoading(true);
                setHasError(false);
            }

            // Set 5-second timeout
            const timeoutPromise = new Promise((_, reject) => {
                timeoutId = setTimeout(() => reject(new Error('Request timeout')), 5000);
            });

            try {
                const apiPromise = getDashboardApi(`/get_equipment_details_by_client?client_id=${clientId}${managerQuery()}`);
                const { error, result } = await Promise.race([apiPromise, timeoutPromise]);
                
                if (timeoutId) clearTimeout(timeoutId);

                if (!error && result && isMounted) {
                    console.log('Equipment Overview API Response:', result);
                    setEquipmentOverviewData({ result: result.result || [] });
                    setHasError(false);
                } else if (isMounted) {
                    setEquipmentOverviewData({ result: [] });
                    setHasError(true);
                }
            } catch (err) {
                console.error('Error fetching equipment overview:', err);
                if (timeoutId) clearTimeout(timeoutId);
                
                if (isMounted) {
                    // Set default empty data on error or timeout
                    setEquipmentOverviewData({ result: [] });
                    setHasError(true);
                }
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };
        
        if (clientId) {
            fetchData();
        } else {
            setIsLoading(false);
        }
        
        return () => {
            isMounted = false;
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [clientId]);

    useEffect(() => {
        if (equipmentOverviewData?.result?.length > 0) {
            let dataArray = [];
            let statusType = ["Expired", "Expiring", "Up to date"];

            for (let i = 0; i < statusType.length; i++) {
                dataArray.push({
                    status: statusType[i],
                    count: equipmentOverviewData.result.filter(
                        (elem) => elem.status && elem.status.includes(statusType[i])
                    ).length,
                    data: equipmentOverviewData.result.filter(
                        (elem) => elem.status && elem.status.includes(statusType[i])
                    ),
                });
            }

            setDataSource(dataArray);
        } else {
            // Set default empty data structure when no data
            setDataSource([
                { status: "Expired", count: 0, data: [] },
                { status: "Expiring", count: 0, data: [] },
                { status: "Up to date", count: 0, data: [] }
            ]);
        }

    }, [equipmentOverviewData])

    const showEquipmentOverview = (data) => {
        if (data.data && data.data.length > 0) {
            setShowModalState(prev => ({
                ...prev,
                expiredCerificateData: data.data.sort((a, b) =>
                    a.other_details?.facility_name?.localeCompare(
                        b.other_details?.facility_name || ''
                    ) || 0
                ),
                isExpiredCertificateModal: false,
                isShowModal: true,
                modalTitle: `Equipment ${data.status} List`,
            }));
        }
    }

    const columns = [
        {
            title: "",
            dataIndex: "status",
            key: "status",
            width: "58%",
            render: (_, data) =>
                data.status == "Up to date" ? (
                    <div className="status_main">
                        <div className="status_dot_green"></div> Up to Date
                    </div>
                ) : data.status.includes("Expiring") ? (
                    <div className="status_main">
                        <div className="status_dot_yellow"></div>Expiring Soon
                    </div>
                ) : (
                    <div className="status_main">
                        <div className="status_dot_red"></div> Expired
                    </div>
                ),
        },
        {
            title: "",
            dataIndex: "count",
            key: "count",
            // render: (_, data) => this.filterDataForEquipment(data,"Up to date").length
        },
        {
            title: "",
            dataIndex: "action",
            key: "action",
            render: (_, data) => (
                <div
                    onClick={() => {
                        showEquipmentOverview(data);
                    }}
                    style={{ cursor: "pointer" }}
                >
                    <div className="chart-details-icon"> <RightOutlined />  </div>
                </div>
            ),
        },
    ];

    return (
        <div className="title-container">
            <div className="mb-3">
                Equipment Overview
            </div>

            <div className="dashboard-table">
                {
                   isLoading ? (
                        <div style={{ height: "200px", width: "100%" }} className="d-flex justify-content-center align-items-center">
                            <Spin />
                        </div>
                    ) : hasError ? (
                        <div style={{ height: "200px", width: "100%" }} className="d-flex justify-content-center align-items-center">
                            <span style={{ color: '#999' }}>Unable to load equipment data</span>
                        </div>
                    ) : (
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                        />
                    )
                }
            </div>
        </div>
    )
}

export default EquipmentOverview;